export const FREE_TRIAL_DAYS = 14;

/** The plan a shop without any subscription is on */
export const FREE_PLAN_HANDLE = 'pb2610-free';

export const PRO_PLAN_HANDLE = 'pb2610-pro';

export const PLUS_PLAN_HANDLE = 'pb2610-plus';
